var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 300C0 134.315 134.315 0 300 0V0C465.685 0 600 134.315 600 300V300C600 465.685 465.685 600 300 600V600C134.315 600 0 465.685 0 300V300Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.001 76L292.697 98.4667H269.081L288.188 112.35L280.894 134.817L300.001 120.933L319.108 134.817L311.814 112.35L330.921 98.4667H307.306L300.001 76Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M307.306 488.627L300.001 466.16L292.697 488.627H269.081L288.188 502.51L280.894 524.977L300.001 511.094L319.108 524.977L311.814 502.51L330.921 488.627H307.306Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.92 316.013L124.027 329.896L116.733 307.429L135.84 293.546H112.225L104.92 271.08L97.6155 293.546H74L93.107 307.429L85.8132 329.896L104.92 316.013Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.459 102.14L195.155 124.596H171.539L190.646 138.49L183.352 160.957L202.459 147.063L221.566 160.957L214.272 138.49L233.379 124.596H209.764L202.459 102.14Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.061 173.541L123.756 196.007H100.13L119.248 209.89L111.943 232.357L131.061 218.474L150.168 232.357L142.863 209.89L161.981 196.007H138.355L131.061 173.541Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.355 391.086L131.061 368.62L123.756 391.086H100.13L119.248 404.97L111.943 427.436L131.061 413.553L150.168 427.436L142.863 404.97L161.981 391.086H138.355Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.764 462.485L202.459 440.019L195.155 462.485H171.539L190.646 476.379L183.352 498.846L202.459 484.952L221.566 498.846L214.272 476.379L233.379 462.485H209.764Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M526 293.546H502.384L495.079 271.08L487.775 293.546H464.159L483.266 307.429L475.972 329.896L495.079 316.013L514.186 329.896L506.893 307.429L526 293.546Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M397.54 102.14L390.236 124.596H366.62L385.727 138.49L378.433 160.957L397.54 147.063L416.647 160.957L409.353 138.49L428.46 124.596H404.845L397.54 102.14Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M457.138 209.89L449.834 232.357L468.941 218.474L488.059 232.357L480.754 209.89L499.872 196.007H476.245L468.941 173.541L461.647 196.007H438.021L457.138 209.89Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M476.245 391.086L468.941 368.62L461.647 391.086H438.021L457.138 404.97L449.834 427.436L468.941 413.553L488.059 427.436L480.754 404.97L499.872 391.086H476.245Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M404.845 462.485L397.54 440.019L390.236 462.485H366.62L385.727 476.379L378.433 498.846L397.54 484.952L416.647 498.846L409.353 476.379L428.46 462.485H404.845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuFlag);
export default __webpack_public_path__ + "static/media/euFlag.4b78ea0854753acc2281899b642a57b7.svg";
export { ForwardRef as ReactComponent };